import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { actions } from 'modules/user';
import RecurringPaymentCard from '../RecurringPaymentCard';
import WLCCancelModal from '../../components/WLCCancelModal';

const UserInfoContainer = ({ user, loadOrderHistory, justShowBanner }) => {
  const [orders, setOrders] = useState(null);
  const [noChangeSubscriptionFlow, setNoChangeSubscriptionFlow] = useState(false);
  const [cancelModalState, setCancelModalState] = useState({ isOpen: false, subscriptionId: null });

  const openCancelModal = useCallback(subscriptionId => {
    setCancelModalState({ isOpen: true, subscriptionId });
  }, []);
  const closeCancelModal = useCallback(() => {
    setCancelModalState({ isOpen: false, subscriptionId: null });
    updateOrders();
  }, []);

  useEffect(() => {
    // this gets called by profile container
    setOrders(user.orders);
  }, [user.orders]);

  const updateOrders = useCallback(
    (stateProps = {}) => {
      return loadOrderHistory().then(newOrders => {
        setOrders(newOrders);
        if (stateProps.noChangeSubscriptionFlow !== undefined) {
          setNoChangeSubscriptionFlow(stateProps.noChangeSubscriptionFlow);
        }
      });
    },
    [loadOrderHistory]
  );

  const currentOrders = orders && orders.length ? orders : user.orders;

  const subscriptions = (currentOrders || []).filter(
    order =>
      !!order.subscription &&
      !!order.Subscription &&
      !order.Subscription.canceled &&
      order.Subscription.FirstOrderId === order.id
  );

  return (
    <div>
      <WLCCancelModal
        isOpen={cancelModalState.isOpen}
        subscription={subscriptions.find(sub => sub.id === cancelModalState.subscriptionId)}
        toggle={closeCancelModal}
      />
      {subscriptions.length ? (
        subscriptions.map(subscription => (
          <RecurringPaymentCard
            order={subscription}
            key={subscription.id}
            updateOrders={updateOrders}
            noChangeSubscriptionFlow={noChangeSubscriptionFlow}
            allSubscriptions={subscriptions}
            justShowBanner={justShowBanner}
            openCancelModal={openCancelModal}
          />
        ))
      ) : (
        <h5>
          <em>None</em>
        </h5>
      )}
    </div>
  );
};

UserInfoContainer.propTypes = {};

export default connect(
  state => ({
    user: state.user
  }),
  {
    loadOrderHistory: actions.loadOrderHistory
  }
)(UserInfoContainer);
